const middleware = {}

middleware['header'] = require('../middleware/header.js')
middleware['header'] = middleware['header'].default || middleware['header']

middleware['redirect'] = require('../middleware/redirect.js')
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

export default middleware
